import AppLoader from "@/components/AppLoader";
import routes from "@/router/routes";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

const FALLBACK_EXIT_DELAY_MS = 6000;

const LoggingOutScreen = () => {
    const { t } = useTranslation();

    useEffect(() => {
        const timer = setTimeout(() => {
            window.location.assign(routes.root);
        }, FALLBACK_EXIT_DELAY_MS);

        return () => clearTimeout(timer);
    }, []);

    return <AppLoader message={t("auth.loggingOut")} withLogout={false} />;
};

export default LoggingOutScreen;
